import React, { Fragment, useState, useEffect, useRef } from "react";
import env from "../../../config/env";
import { Input, Radio, Select, DatePicker, InputNumber, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import data from "../../../constants/retailPos.json";
import { v4 as uuidv4 } from "uuid";
import { useWindowDimensions } from "../../../lib/useViewport";
import "../../style.css";
import "../../globalStyles.css";
import groupBy from "lodash/groupBy";
import useAuthStore from "../../../stores/useAuthStore";
import useReferenceStore from "../../../stores/useReferenceStore";
import {
  UAECustomerSearchDrawer,
  UAECustomerCreationDrawer,
  PaymentMethodModal,
  OrderHistoryModal,
  AddOnSelectionDrawer,
  CustomAttributesModal,
  CustomAttributesDrawer,
  CustomerSearchDrawer,
  AddCustomerDrawer,
  EditCustomerDrawer,
  ParkedBillsModal,
  AddOnConfirmationModal,
  UploadDocumentModal,
} from "./modals";
import { verifyCouponsService } from "../../../services/index";

const PointOfSaleCoreModals = (props) => {
  const { width } = useWindowDimensions();
  const {
    currentInput,
    setCurrentInput,
    inputValues,
    setInputValues,
    refs,
    paymentModalInputRef,
    customerSearchInputRef,
    displayCustomerSearch,
    closeCustomerSearch,
    setCustomerSearchType,
    customerSearchType,
    handleCustomerSearch,
    customerSearchInput,
    setCustomerSearchResults,
    setCustomerSearchInput,
    customerSearchResults,
    selectCustomer,
    showEditOldCustomerFields,
    showAddNewCustomerFields,
    showAddNewUAECustomerFields,
    setDisplayCustomerSearch,
    displayUAECustomerSearch,
    setDisplayUAECustomerSearch,
    setDisplayAddNewCustomer,
    displayAddNewCustomer,
    form,
    UAECustomerForm,
    addNewCustomer,
    setDisplayEditOldCustomer,
    displayEditOldCustomer,
    editOldCustomer,
    paymentModal,
    tillDataPaymentMethods,
    setSelectedPaymentMethod,
    openPaymentModalByCustomer,
    selectedPaymentMethod,
    cart,
    requestPayment,
    setCouponModalVisible,
    closePaymentModal,
    paymentModalLoyalityMessages,
    amount,
    onChangeAmount,
    processOrder,
    handleAmount,
    currencyType,
    editFlag,
    setEditFlag,
    // Order History Modal //
    displayOrderHistory,
    setDisplayOrderHistory,
    searchOrderHistory,
    showOrderHistory,
    setOrderHistoryInput,
    orderHistoryDetails,
    showOrderHistoryLine,
    selectedOrderHistoryLine,
    isPrintModeXML,
    syncOrders,
    changeOrderHistorySearchType,
    orderHistoryInput,
    paymentModalByCustomerState,
    posConfig,
    // TSK-2934: generic payment-data popup trigger (shared state from usePaymentFlow.js,
    // same instance already consumed by RetailModals.js's <PaymentDataPopup> mount)
    setShowPaymentDataPopup,
    setPaymentDataPopupMethod,
    setPaymentDataPopupAmount,
    // Parked Bill Modal //
    filterdParkedList,
    displayParkedBillModal,
    searchParkedBill,
    handleParkedBillSearchInput,
    parkedBillSearchInput,
    selectParkedBill,
    closeParkedBillModal,
    cashManagementForm,
    handleChangeCurrency,
    roundOffValue,
    orderFlag,
    selectedEditOldCustomer,
    setIsInputFocused,
    displayUAECustomer,
    setDisplayUAECustomer,
    // product addon data
    selectedProduct,
    displayAddOnSelection,
    setDisplayAddOnSelection,
    handleAddOnModalClose,
    handleQty,
    addOnsList,
    handleAddOnValue,
    selectedAddons,
    handleAdd,
    isUpdatingAddon,
    setIsUpdatingAddon,
    handleAddOnModal,
    selectedProductInCart,
    setSelectedProductInCart,
    addDefinedProductWithAddons,
    dynamicForm,
    setDynamicForm,
    dynamicModalForm,
    submitCustomAttributs,
    setKeyboardType,
    keyboardType,
    setOpen,
    open,
    layoutName,
    setLayoutName,
    inputName,
    setInputName,
    keyboardInputFields,
    setKeyboardInputFields,
    keyboard,
    setOpenSalesRep,
    verifyStock,
    hasShownCustomerModalRef,
    searchInputRef,
    customersData,
    setCustomersData,
    showPayments,
    setShowPayments,
    currenciesData,
    setCurrenciesData,
    denaminationsKeyboard,
    setDenaminationsKeyboard,
    handleCashPayment,
    onChangeTotalQuantity,
    selectedCustomer,
    setSelectedCustomer,
    isWalletFlag,
    setIswalletFlag,
    isNewGiftCardFlag,
    setIsNewGiftCardFlag,
    isRefundWalletOpen,
    setIsRefundWalletOpen,
    realPrice,
    setRealPrice,
    setCustomerLoading,
    customerLoading,
    setSelectedAddons,
    customerForm,
    customerConfig,
    customerConfigData,
    retailCustomerTabs,
    retailCustomerFields,
    retailCustomerGroups,
    retailCustomerRules,
    retailCustomerb2bSettings,
    retailCustomerApiDataSources,
    activeTab,
    setActiveTab,
    activeTabName,
    setActiveTabName,
    isB2BEnabled,
    setIsB2BEnabled,
    formDataCache,
    setFormDataCache,
    expandedGroups,
    setExpandedGroups,
    setSelectedEditOldCustomer,
    switchToggle,
    setSwitchToggle,
    isViewMode,
    setIsViewMode,
    toCamelCaseMetaData,
    convertMetaDataToKeyValue,
    viewCustomerValues,
    setViewCustomerValues,
    isSubmittingCustomer,
    setIsSubmittingCustomer,
    lastSearchedValue,
    setLastSearchedValue,
    selectedB2BCustomer,
    setSelectedB2BCustomer,
    customerSearchTrigger,
    setCustomerSearchTrigger,
    setKioskUI,
    kioskLogin,
    loading,
    setLoading,
    isPanCustomer,
    setIsPanCustomer,
    panCustomerInfo,
    setPanCustomerInfo,
    documents,
    setDocuments,
    pendingRefundCustomer,
    setPendingRefundCustomer,
    isRefundCustomerEdit,
    setIsRefundCustomerEdit,
    isNriBilling,
    setIsNriBilling,
    retailCustomerOperationalSettings,
    isCreditSale,
    setIsCreditSale,
    autoEnableNriBilling,
    autoEnablePanCustomer,
    selectedReturnType,
    handlePayment,
    paymentType,
    setPaymentType,
    isOnline,
    setShowCardPaymnteModal,
    setCardPaymnetError,
    setNumb,
    panDrawerMode,
    setPanDrawerMode,
    uploadedDocuments,
    setUploadedDocuments,
    uploadModalVisible,
    setUploadModalVisible,
    isPanUpdateMode,
    setIsPanUpdateMode,
    isAddNewCustomer,
    setIsAddNewCustomer,
    additionalInfo,
    setAdditionalInfo,
    processCouponApplication,
    gstInfo,
    setGstInfo,
    compressImage,
    setCouponVerificationData,
    setShowCouponOtpPopup,
    selectedInvoiceAddress,
    setSelectedInvoiceAddress,
    selectedDeliveryAddress,
    setSelectedDeliveryAddress,
  } = props;

  const tillData = useAuthStore((s) => s.tillData);
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const registrationTypes = useReferenceStore.getState().registrationTypes;
  const [addonQty, setAddonQty] = useState({});
  const [modalDisplayDocuments, setModalDisplayDocuments] = useState([]);

  const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const layout = userAccessController.layout;

  const orderHistorySearchInputRef = useRef();
  const paymentCardRef = useRef();
  const cartForPaymentRef = useRef();
  const paymentModalActiveRef = useRef();

  useEffect(() => {
    form.setFieldsValue(inputValues);
  }, [inputValues]);

  useEffect(() => {
    UAECustomerForm.setFieldsValue(inputValues);
  }, [inputValues]);

  useEffect(() => {
    if (displayCustomerSearch || displayUAECustomerSearch) {
      setTimeout(() => {
        customerSearchInputRef.current.focus();
      }, 100);
    }
  }, [displayCustomerSearch, displayUAECustomerSearch]);

  useEffect(() => {
    if (displayOrderHistory) {
      setTimeout(() => {
        orderHistorySearchInputRef?.current?.focus();
      }, 100);
    }
  }, [displayOrderHistory, changeOrderHistorySearchType]);

  useEffect(() => {
    if (paymentModal) {
      setTimeout(() => {
        paymentModalInputRef?.current?.focus();
      }, 100);
    }
  }, [paymentModal, selectedPaymentMethod]);

  const deleteAmountOnCart = () => {
    const pmName = document.activeElement.firstChild.firstChild.firstChild.firstChild.firstChild.firstChild.firstChild.children[1].innerHTML;
    const iN = cartForPaymentRef.current.payments.findIndex((paymentMade) => paymentMade.name === pmName);
    requestPayment(cartForPaymentRef.current.payments[iN], -cartForPaymentRef.current.payments[iN].amount, "allow");
  };

  const handleKey = (e) => {
    const { keyCode } = e;
    if (keyCode === 37) {
      paymentCardRef?.current?.focus();
    }
    if (keyCode === 46) {
      if (paymentModalActiveRef.current) {
        deleteAmountOnCart();
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  useEffect(() => {
    cartForPaymentRef.current = cart;
  }, [cart]);

  useEffect(() => {
    paymentModalActiveRef.current = paymentModal;
  }, [paymentModal]);

  useEffect(() => {
    if (selectedAddons.length > 0) {
      handleAdd();
    }
  }, [selectedAddons]);

  useEffect(() => {
    const allAddons = [...(addOnsList?.requiredList || []), ...(addOnsList?.optionsList || [])];
    if (displayAddOnSelection && allAddons.length) {
      const init = Object.fromEntries(allAddons.map((a) => [a.mProductAddOnId, 0]));
      setAddonQty(init);
    }
  }, [displayAddOnSelection, addOnsList]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && displayCustomerSearch) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      document.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [displayCustomerSearch]);

  const getGroupItems = (groupName) => {
    if (!addOnsList?.requiredList) return [];
    return addOnsList.requiredList.filter((addon) => (addon.mAddonGroup && addon.mAddonGroup.name) === groupName);
  };

  const getGroupTotalQty = (groupName) => {
    const items = getGroupItems(groupName);
    return items.reduce((t, item) => t + (Number(addonQty[item.mProductAddOnId]) || 0), 0);
  };

  const validateAddonSelection = async () => {
    const allAddons = [...(addOnsList?.requiredList || []), ...(addOnsList?.optionsList || [])];
    if (!allAddons.length) {
      await handleAdd();
      return;
    }

    const groups = groupBy(allAddons, (item) => item?.mAddonGroup?.name);

    const selected = [];
    Object.entries(addonQty).forEach(([id, qty]) => {
      if (qty > 0) {
        const addonData = allAddons.find((a) => a.mProductAddOnId === id);
        if (addonData) {
          selected.push({ ...addonData, qty });
        }
      }
    });

    for (const groupName in groups) {
      const groupItems = groups[groupName];
      const groupInfo = groupItems[0].mAddonGroup;

      const min = Number(groupInfo.minqty || 0);
      const max = Number(groupInfo.maxqty || Infinity);
      const allowQty = groupInfo.allowQtySelection === "Y";

      const total = groupItems.reduce((sum, item) => sum + (Number(addonQty[item.mProductAddOnId]) || 0), 0);

      if (total < min) {
        return message.error(allowQty ? `Please select total quantity of at least ${min} for ${groupName}` : `Please select at least ${min} options in ${groupName}`);
      }

      if (total > max) {
        return message.error(allowQty ? `You can select only total quantity of ${max} for ${groupName}` : `You can select only ${max} options in ${groupName}`);
      }
    }

    const addonsWithWeight = selected.map((addon) => ({
      ...addon,
      weight: selectedProduct?.weight || 1,
      addonQty: addon.qty,
    }));

    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        selectedAddons: addonsWithWeight,
        weight: selectedProduct?.weight || 1,
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice,
      true
    );

    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  // Scrollbar render props (used by UAECustomerCreationDrawer)
  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = { backgroundColor: "#c1c1c1", borderRadius: "5px", width: "8px" };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const renderThumbHorizontalScroll = ({ style, ...props }) => {
    return <div style={{ ...style, width: "0px" }} {...props} />;
  };

  const renderView = ({ style, ...props }) => {
    return <div className="box" style={{ ...style, color: "#00000" }} {...props} />;
  };

  // Virtual keyboard helpers (used by UAE drawers)
  const onFocusInput = (fieldName) => {
    setInputName(fieldName);
    setOpen(true);
    setTimeout(() => {
      const currentInputValue = keyboardInputFields[fieldName] || "";
      keyboard?.current?.setInput(currentInputValue);
    }, 300);
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    setKeyboardInputFields({ ...keyboardInputFields, [inputName]: inputVal });
    keyboard?.current?.setInput(inputVal);
  };

  const getInputValue = (inputName) => {
    return keyboardInputFields[inputName] || "";
  };

  // Custom Attributes form handlers
  const cancelDynamicModal = () => {
    setDynamicForm(false);
    setSelectedProductInCart({});
    dynamicModalForm.resetFields();
  };

  const handleSubmit = () => {
    dynamicModalForm
      .validateFields()
      .then((values) => {
        const formattedValues = Object.entries(values).reduce((acc, [key, value]) => {
          if (value && (value._isAMomentObject || value.$isDayjsObject) && typeof value.format === "function") {
            acc[key] = value.format("DD-MM-YYYY");
          } else {
            acc[key] = value;
          }
          return acc;
        }, {});

        if (selectedProductInCart.customAttributes) {
          selectedProductInCart.customAttributes.map((item) => {
            if (item.type === "TXT") {
              selectedProductInCart.customText = formattedValues[item.name];
            }
          });
        }
        setDynamicForm(false);
        selectedProductInCart.newCustomAttributes = [formattedValues];
        selectedProductInCart.qty = 1;
        submitCustomAttributs(selectedProductInCart);
        dynamicModalForm.resetFields();
      })
      .catch((errorInfo) => {
      });
  };

  const renderFormItem = (field) => {
    const { name, type, defaultValue, values } = field;
    switch (type) {
      case "STR":
        return <Input defaultValue={defaultValue} style={{ width: "30vw" }} />;
      case "TXT":
        return <TextArea defaultValue={defaultValue} style={{ width: "30vw" }} />;
      case "DAT":
        return <DatePicker format={"DD-MM-YYYY"} />;
      case "NUM":
        return <InputNumber defaultValue={defaultValue} />;
      case "LST":
        return (
          <Select defaultValue={defaultValue} className="attribute" style={{ width: "30vw", border: "1px solid #d9d9d9" }}>
            {values?.split(",").map((item) => (
              <Select.Option key={item} value={item}>
                {item}
              </Select.Option>
            ))}
          </Select>
        );
      case "YEN":
        return (
          <Radio.Group defaultValue={defaultValue}>
            <Radio value="Y">Yes</Radio>
            <Radio value="N">No</Radio>
          </Radio.Group>
        );
      default:
        return null;
    }
  };

  // Upload document helpers
  const compressImageLocal = (file, maxWidth = 1920, quality = 0.75) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        image.src = e.target.result;
      };
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        let width = image.width;
        let height = image.height;
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(image, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Image compression failed"));
              return;
            }
            const compressedFile = new File([blob], file.name, { type: file.type, lastModified: Date.now() });
            resolve(compressedFile);
          },
          file.type,
          quality
        );
      };
      image.onerror = (err) => reject(err);
      reader.onerror = (err) => reject(err);
    });
  };

  const handleFileUpload = async (e, docName) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const fileToUpload = file.size > 4 * 1024 * 1024 && file.type.startsWith("image/") ? await compressImageLocal(file, 1920, 0.75) : file;
      const buffer = await fileToUpload.arrayBuffer();
      const fileData = Array.from(new Uint8Array(buffer));
      const response = await fetch(env.uploadDocumentUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fileName: fileToUpload.name, fileType: fileToUpload.type, fileData }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result?.error || "Upload failed");
      const { url } = result;
      setDocuments((prev) => [...prev, { docID: "", docName, docUrl: url, fileName: file.name }]);
      message.success("Attachment has been uploaded succesfully.");
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Failed to upload document");
    }
  };

  const getCustomerDocumentsFromCart = (cart, selectedEditOldCustomer, isAddMode = false) => {
    if (isAddMode) return [];
    const meta = selectedEditOldCustomer?.metaData || cart?.customer?.metaData || [];
    const docMeta = meta.find((m) => m.key === "CUSTOMER_DOCUMENT_URLS") || meta.find((m) => m.key === "C USTOMERDOCUMENTURLS");
    if (!docMeta?.value) return [];
    try {
      const urls = JSON.parse(docMeta.value);
      const uniqueUrls = [...new Set(urls)];
      return uniqueUrls.map((url, index) => ({
        docID: `cart_${index}`,
        docName: "Customer Document",
        docUrl: url,
        fileName: url.split("/").pop(),
      }));
    } catch {
      return [];
    }
  };

  useEffect(() => {
    if (!uploadModalVisible) return;
    if (displayAddNewCustomer) {
      setModalDisplayDocuments(documents.filter((doc) => doc.docName === "Customer Document"));
    } else {
      const cartDocuments = getCustomerDocumentsFromCart(cart, selectedEditOldCustomer);
      const existingUrls = new Set(cartDocuments.map((d) => d.docUrl));
      const newDocs = documents.filter((doc) => doc.docName === "Customer Document" && !existingUrls.has(doc.docUrl));
      const merged = [...cartDocuments, ...newDocs];
      const seen = new Set();
      const deduped = merged.filter((doc) => {
        if (seen.has(doc.docUrl)) return false;
        seen.add(doc.docUrl);
        return true;
      });
      setModalDisplayDocuments(deduped);
    }
  }, [uploadModalVisible, documents, cart, selectedEditOldCustomer]);

  return (
    <Fragment>
      {uploadModalVisible && (
        <UploadDocumentModal
          open={true}
          onCancel={() => setUploadModalVisible(false)}
          isViewMode={isViewMode}
          displayDocuments={modalDisplayDocuments}
          onUpload={handleFileUpload}
        />
      )}

      {/* CUSTOMER SEARCH DRAWER (extracted) */}
      {displayCustomerSearch && (
        <CustomerSearchDrawer
          displayCustomerSearch={displayCustomerSearch}
          closeCustomerSearch={closeCustomerSearch}
          customerSearchInputRef={customerSearchInputRef}
          customerSearchInput={customerSearchInput}
          setCustomerSearchInput={setCustomerSearchInput}
          customerSearchResults={customerSearchResults}
          setCustomerSearchResults={setCustomerSearchResults}
          selectCustomer={selectCustomer}
          showAddNewCustomerFields={showAddNewCustomerFields}
          showEditOldCustomerFields={showEditOldCustomerFields}
          setDisplayCustomerSearch={setDisplayCustomerSearch}
          setDisplayAddNewCustomer={setDisplayAddNewCustomer}
          setDisplayEditOldCustomer={setDisplayEditOldCustomer}
          setLayoutName={setLayoutName}
          setInputName={setInputName}
          setOpen={setOpen}
          keyboard={keyboard}
          setEditFlag={setEditFlag}
          setIsViewMode={setIsViewMode}
          setSelectedEditOldCustomer={setSelectedEditOldCustomer}
          setActiveTabName={setActiveTabName}
          cart={cart}
          tillData={tillData}
          posConfig={posConfig}
          retailCustomerRules={retailCustomerRules}
          retailCustomerFields={retailCustomerFields}
          customerForm={customerForm}
          convertMetaDataToKeyValue={convertMetaDataToKeyValue}
          setViewCustomerValues={setViewCustomerValues}
          autoEnablePanCustomer={autoEnablePanCustomer}
          autoEnableNriBilling={autoEnableNriBilling}
          verifyStock={verifyStock}
          hasShownCustomerModalRef={hasShownCustomerModalRef}
          loading={loading}
          setLoading={setLoading}
          onChangeInput={onChangeInput}
        />
      )}

      {/* ADD NEW CUSTOMER DRAWER (extracted) */}
      {displayAddNewCustomer && (
        <AddCustomerDrawer
          displayAddNewCustomer={displayAddNewCustomer}
          setDisplayAddNewCustomer={setDisplayAddNewCustomer}
          setDisplayCustomerSearch={setDisplayCustomerSearch}
          customerForm={customerForm}
          form={form}
          addNewCustomer={addNewCustomer}
          editOldCustomer={editOldCustomer}
          customerSearchInput={customerSearchInput}
          setCustomerSearchInput={setCustomerSearchInput}
          setCustomerSearchResults={setCustomerSearchResults}
          retailCustomerTabs={retailCustomerTabs}
          retailCustomerFields={retailCustomerFields}
          retailCustomerGroups={retailCustomerGroups}
          retailCustomerRules={retailCustomerRules}
          retailCustomerb2bSettings={retailCustomerb2bSettings}
          retailCustomerApiDataSources={retailCustomerApiDataSources}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeTabName={activeTabName}
          setActiveTabName={setActiveTabName}
          isB2BEnabled={isB2BEnabled}
          setIsB2BEnabled={setIsB2BEnabled}
          formDataCache={formDataCache}
          setFormDataCache={setFormDataCache}
          expandedGroups={expandedGroups}
          setExpandedGroups={setExpandedGroups}
          switchToggle={switchToggle}
          setSwitchToggle={setSwitchToggle}
          isViewMode={isViewMode}
          setIsViewMode={setIsViewMode}
          toCamelCaseMetaData={toCamelCaseMetaData}
          convertMetaDataToKeyValue={convertMetaDataToKeyValue}
          isSubmittingCustomer={isSubmittingCustomer}
          setIsSubmittingCustomer={setIsSubmittingCustomer}
          lastSearchedValue={lastSearchedValue}
          setLastSearchedValue={setLastSearchedValue}
          selectedB2BCustomer={selectedB2BCustomer}
          setSelectedB2BCustomer={setSelectedB2BCustomer}
          posConfig={posConfig}
          cart={cart}
          refs={refs}
          setKeyboardInputFields={setKeyboardInputFields}
          keyboardInputFields={keyboardInputFields}
          keyboard={keyboard}
          setOpen={setOpen}
          open={open}
          setInputName={setInputName}
          inputName={inputName}
          setOpenSalesRep={setOpenSalesRep}
          selectedEditOldCustomer={selectedEditOldCustomer}
          setSelectedEditOldCustomer={setSelectedEditOldCustomer}
          customerConfigData={customerConfigData}
          setKioskUI={setKioskUI}
          kioskLogin={kioskLogin}
          loading={loading}
          setLoading={setLoading}
          isPanCustomer={isPanCustomer}
          setIsPanCustomer={setIsPanCustomer}
          panCustomerInfo={panCustomerInfo}
          setPanCustomerInfo={setPanCustomerInfo}
          documents={documents}
          setDocuments={setDocuments}
          isNriBilling={isNriBilling}
          setIsNriBilling={setIsNriBilling}
          isCreditSale={isCreditSale}
          setIsCreditSale={setIsCreditSale}
          retailCustomerOperationalSettings={retailCustomerOperationalSettings}
          displayEditOldCustomer={displayEditOldCustomer}
          pendingRefundCustomer={pendingRefundCustomer}
          setPendingRefundCustomer={setPendingRefundCustomer}
          isRefundCustomerEdit={isRefundCustomerEdit}
          setIsRefundCustomerEdit={setIsRefundCustomerEdit}
          searchInputRef={searchInputRef}
          setCustomerLoading={setCustomerLoading}
          customerLoading={customerLoading}
          panDrawerMode={panDrawerMode}
          isAddNewCustomer={isAddNewCustomer}
          setIsAddNewCustomer={setIsAddNewCustomer}
          gstInfo={gstInfo}
          setGstInfo={setGstInfo}
          selectedInvoiceAddress={selectedInvoiceAddress}
          setSelectedInvoiceAddress={setSelectedInvoiceAddress}
          selectedDeliveryAddress={selectedDeliveryAddress}
          setSelectedDeliveryAddress={setSelectedDeliveryAddress}
          processCouponApplication={processCouponApplication}
          setAdditionalInfo={setAdditionalInfo}
          setShowCouponOtpPopup={setShowCouponOtpPopup}
          setCouponVerificationData={setCouponVerificationData}
          setDisplayEditOldCustomer={setDisplayEditOldCustomer}
        />
      )}

      {/* EDIT CUSTOMER DRAWER (extracted) */}
      {displayEditOldCustomer && (
        <EditCustomerDrawer
          displayEditOldCustomer={displayEditOldCustomer}
          setDisplayEditOldCustomer={setDisplayEditOldCustomer}
          editFlag={editFlag}
          setEditFlag={setEditFlag}
          editOldCustomer={editOldCustomer}
          closeCustomerSearch={closeCustomerSearch}
          form={form}
          customerForm={customerForm}
          cart={cart}
          selectedEditOldCustomer={selectedEditOldCustomer}
          setSelectedEditOldCustomer={setSelectedEditOldCustomer}
          customerSearchInput={customerSearchInput}
          setCustomerSearchInput={setCustomerSearchInput}
          setCustomerSearchResults={setCustomerSearchResults}
          retailCustomerTabs={retailCustomerTabs}
          retailCustomerFields={retailCustomerFields}
          retailCustomerGroups={retailCustomerGroups}
          retailCustomerRules={retailCustomerRules}
          retailCustomerb2bSettings={retailCustomerb2bSettings}
          retailCustomerApiDataSources={retailCustomerApiDataSources}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          activeTabName={activeTabName}
          setActiveTabName={setActiveTabName}
          isB2BEnabled={isB2BEnabled}
          setIsB2BEnabled={setIsB2BEnabled}
          formDataCache={formDataCache}
          setFormDataCache={setFormDataCache}
          expandedGroups={expandedGroups}
          setExpandedGroups={setExpandedGroups}
          switchToggle={switchToggle}
          setSwitchToggle={setSwitchToggle}
          isViewMode={isViewMode}
          setIsViewMode={setIsViewMode}
          toCamelCaseMetaData={toCamelCaseMetaData}
          convertMetaDataToKeyValue={convertMetaDataToKeyValue}
          isSubmittingCustomer={isSubmittingCustomer}
          setIsSubmittingCustomer={setIsSubmittingCustomer}
          lastSearchedValue={lastSearchedValue}
          setLastSearchedValue={setLastSearchedValue}
          selectedB2BCustomer={selectedB2BCustomer}
          setSelectedB2BCustomer={setSelectedB2BCustomer}
          posConfig={posConfig}
          refs={refs}
          setKeyboardInputFields={setKeyboardInputFields}
          keyboardInputFields={keyboardInputFields}
          keyboard={keyboard}
          setOpen={setOpen}
          open={open}
          setInputName={setInputName}
          inputName={inputName}
          customerConfigData={customerConfigData}
          setKioskUI={setKioskUI}
          kioskLogin={kioskLogin}
          loading={loading}
          setLoading={setLoading}
          isPanCustomer={isPanCustomer}
          setIsPanCustomer={setIsPanCustomer}
          panCustomerInfo={panCustomerInfo}
          setPanCustomerInfo={setPanCustomerInfo}
          isNriBilling={isNriBilling}
          setIsNriBilling={setIsNriBilling}
          isCreditSale={isCreditSale}
          setIsCreditSale={setIsCreditSale}
          retailCustomerOperationalSettings={retailCustomerOperationalSettings}
          displayAddNewCustomer={displayAddNewCustomer}
          setDisplayAddNewCustomer={setDisplayAddNewCustomer}
          pendingRefundCustomer={pendingRefundCustomer}
          setPendingRefundCustomer={setPendingRefundCustomer}
          isRefundCustomerEdit={isRefundCustomerEdit}
          setIsRefundCustomerEdit={setIsRefundCustomerEdit}
          searchInputRef={searchInputRef}
          setCustomerLoading={setCustomerLoading}
          customerLoading={customerLoading}
          gstInfo={gstInfo}
          setGstInfo={setGstInfo}
          selectedInvoiceAddress={selectedInvoiceAddress}
          setSelectedInvoiceAddress={setSelectedInvoiceAddress}
          selectedDeliveryAddress={selectedDeliveryAddress}
          setSelectedDeliveryAddress={setSelectedDeliveryAddress}
          processCouponApplication={processCouponApplication}
          setAdditionalInfo={setAdditionalInfo}
          setShowCouponOtpPopup={setShowCouponOtpPopup}
          setCouponVerificationData={setCouponVerificationData}
          documents={documents}
          setDocuments={setDocuments}
        />
      )}

      {/* UAE CUSTOMER SEARCH DRAWER */}
      {displayUAECustomerSearch && (
        <UAECustomerSearchDrawer
          displayUAECustomerSearch={displayUAECustomerSearch}
          closeCustomerSearch={closeCustomerSearch}
          customerSearchInputRef={customerSearchInputRef}
          customerSearchInput={customerSearchInput}
          setCustomerSearchInput={setCustomerSearchInput}
          customerSearchResults={customerSearchResults}
          setCustomerSearchResults={setCustomerSearchResults}
          selectCustomer={selectCustomer}
          showEditOldCustomerFields={showEditOldCustomerFields}
          setEditFlag={setEditFlag}
          showAddNewUAECustomerFields={showAddNewUAECustomerFields}
          getInputValue={getInputValue}
          onFocusInput={onFocusInput}
          onChangeInput={onChangeInput}
        />
      )}

      {/* UAE CUSTOMER CREATION DRAWER */}
      {displayUAECustomer && (
        <UAECustomerCreationDrawer
          displayUAECustomer={displayUAECustomer}
          setDisplayUAECustomer={setDisplayUAECustomer}
          UAECustomerForm={UAECustomerForm}
          setInputValues={setInputValues}
          registrationTypes={registrationTypes}
          refs={refs}
          getInputValue={getInputValue}
          onChangeInput={onChangeInput}
          onFocusInput={onFocusInput}
          renderThumbHorizontalScroll={renderThumbHorizontalScroll}
          renderThumb={renderThumb}
          customerLoading={customerLoading}
          addNewCustomer={addNewCustomer}
          setCustomerSearchInput={setCustomerSearchInput}
        />
      )}

      {/* PAYMENT MODAL */}
      {paymentModal && (
        <PaymentMethodModal
          paymentModal={paymentModal}
          tillData={tillData}
          tillDataPaymentMethods={tillDataPaymentMethods}
          posConfig={posConfig}
          cart={cart}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          openPaymentModalByCustomer={openPaymentModalByCustomer}
          paymentCardRef={paymentCardRef}
          paymentModalInputRef={paymentModalInputRef}
          amount={amount}
          onChangeAmount={onChangeAmount}
          handleAmount={handleAmount}
          requestPayment={requestPayment}
          paymentModalLoyalityMessages={paymentModalLoyalityMessages}
          processOrder={processOrder}
          setCouponModalVisible={setCouponModalVisible}
          closePaymentModal={closePaymentModal}
          currenciesList={currenciesList}
          width={width}
          setShowPaymentDataPopup={setShowPaymentDataPopup}
          setPaymentDataPopupMethod={setPaymentDataPopupMethod}
          setPaymentDataPopupAmount={setPaymentDataPopupAmount}
          data={data}
        />
      )}

      {/* ORDER HISTORY MODAL */}
      {displayOrderHistory && (
        <OrderHistoryModal
          displayOrderHistory={displayOrderHistory}
          setDisplayOrderHistory={setDisplayOrderHistory}
          searchOrderHistory={searchOrderHistory}
          showOrderHistory={showOrderHistory}
          setOrderHistoryInput={setOrderHistoryInput}
          orderHistoryDetails={orderHistoryDetails}
          showOrderHistoryLine={showOrderHistoryLine}
          selectedOrderHistoryLine={selectedOrderHistoryLine}
          isPrintModeXML={isPrintModeXML}
          syncOrders={syncOrders}
          changeOrderHistorySearchType={changeOrderHistorySearchType}
          orderHistoryInput={orderHistoryInput}
          orderHistorySearchInputRef={orderHistorySearchInputRef}
          data={data}
          currenciesList={currenciesList}
        />
      )}

      {/* PARKED BILLS MODAL */}
      {displayParkedBillModal && (
        <ParkedBillsModal
          filteredList={filterdParkedList}
          onClose={closeParkedBillModal}
          onSearch={searchParkedBill}
          onSearchChange={handleParkedBillSearchInput}
          searchValue={parkedBillSearchInput}
          onSelect={selectParkedBill}
        />
      )}

      {/* ADD-ON SELECTION DRAWER */}
      {displayAddOnSelection && (
        <AddOnSelectionDrawer
          displayAddOnSelection={displayAddOnSelection}
          layout={layout}
          handleAddOnModalClose={handleAddOnModalClose}
          selectedProduct={selectedProduct}
          currenciesList={currenciesList}
          addOnsList={addOnsList}
          addonQty={addonQty}
          setAddonQty={setAddonQty}
          validateAddonSelection={validateAddonSelection}
        />
      )}

      {/* ADD-ON CONFIRMATION MODAL */}
      {isUpdatingAddon && (
        <AddOnConfirmationModal
          open={true}
          onCancel={() => setIsUpdatingAddon(false)}
          onChoose={() => {
            setDisplayAddOnSelection(true);
            setIsUpdatingAddon(false);
            handleAddOnModal(selectedProduct, 1);
          }}
          onRepeat={() => {
            selectedProductInCart.qty = 1;
            setIsUpdatingAddon(false);
            addDefinedProductWithAddons(selectedProductInCart, 1);
          }}
        />
      )}

      {/* CUSTOM ATTRIBUTES DRAWER (v2 — sections, pricing, rich widgets) */}
      {dynamicForm && (
        <CustomAttributesDrawer
          open={true}
          onCancel={cancelDynamicModal}
          selectedProduct={selectedProductInCart}
          onSubmit={({ newCustomAttributes, pricing, qty, perUnit, weight }) => {
            // Push the drawer's computed values into the product so the rest
            // of the cart flow (addProductToCart → pricing / taxes / totals)
            // uses the customised per-unit price instead of base sunitprice.
            const p = { ...selectedProductInCart };
            p.newCustomAttributes = newCustomAttributes;
            // Preserve legacy customText used by some receipt templates for TXT fields.
            (p.customAttributes || []).forEach((item) => {
              if (item.type === "TXT" && newCustomAttributes[0]?.[item.name]) {
                p.customText = newCustomAttributes[0][item.name];
              }
            });
            // When the drawer collected the weight (isManualQty + customAttributes flow),
            // use it as both weight and qty so pricing / cart totals are correct.
            if (weight !== undefined && weight > 0) {
              p.weight = parseFloat(weight.toFixed(p.isQtyDesimal ?? 2));
              p.qty = p.weight;
            } else {
              p.qty = qty || 1;
            }
            if (perUnit && perUnit > 0) {
              p.sunitprice = perUnit;
              p.realPrice = perUnit;
              p.salePrice = perUnit;
              p.originalPrice = perUnit;
              p.listPrice = perUnit;
            }
            p.customAttributePricing = pricing;
            setDynamicForm(false);
            submitCustomAttributs(p);
          }}
        />
      )}
    </Fragment>
  );
};

export default PointOfSaleCoreModals;
